import { useCallback, useState } from "react";
import { ApiError, postApi } from "../../../../utils/api.ts";
import { accessToken } from "../../../../utils/auth.ts";
import { API_OFFBOARDING_APPROVAL } from "../../../../../config/Endpoints.js";
import { useSqeLabs } from "../../../../hooks/use-sqe-labs.ts";
import { SQE_OFFBOARDING_URL } from "../api/sqe-offboarding-api.ts";

export function useOffboardingApproval() {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const isSqe = useSqeLabs();

    const approve = useCallback(
        async (offboardingId: number, finalLwd: string, remarks: string) => {
            setLoading(true);
            setError(null);

            const payload = {
                offboardingId,
                role: "COO",
                action: isSqe ? "APPROVED" : "APPROVE",
                finalLwd,
                remarks,
            };

            try {
                await postApi(
                    isSqe ? `${SQE_OFFBOARDING_URL}/approval` : API_OFFBOARDING_APPROVAL,
                    accessToken(),
                    payload as unknown as Record<string, unknown>,
                );
                return true;
            } catch (e) {
                const msg =
                    e instanceof ApiError
                        ? e.message
                        : "Failed to approve offboarding request.";
                setError(msg);
                return false;
            } finally {
                setLoading(false);
            }
        },
        [isSqe],
    );

    const reject = useCallback(async (offboardingId: number, remarks: string) => {
        setLoading(true);
        setError(null);

        const payload = {
            offboardingId,
            role: "COO",
            action: isSqe ? "REJECTED" : "REJECT",
            remarks,
        };

        try {
            await postApi(
                isSqe ? `${SQE_OFFBOARDING_URL}/approval` : API_OFFBOARDING_APPROVAL,
                accessToken(),
                payload as unknown as Record<string, unknown>,
            );
            return true;
        } catch (e) {
            const msg =
                e instanceof ApiError
                    ? e.message
                    : "Failed to reject offboarding request.";
            setError(msg);
            return false;
        } finally {
            setLoading(false);
        }
    }, [isSqe]);

    return { approve, reject, loading, error };
}
